import { getAxiosClient } from "../../../services/HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { DataSource } from "./administration-interface";

export const fetchDataSources = createAsyncThunk(
  "administration/fetchDataSources",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_sys_admin_datasource_config`);
    return response.data as DataSource[];
  }
);
